import { DocumentIcon } from '@heroicons/react/outline';

export function OtherFileIcon() {
  return <DocumentIcon className="h-full text-file-other-enabled" />;
}
